import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Alert, Button, Card, DatePicker, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { getBusinessClients, getCodeById, updateCode } from "../../store/slices/codeSlice";

const EditCode = () => {
    const { id } = useParams()
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { businessClients } = useSelector((state) => state?.code)
    useEffect(() => {
        dispatch(getCodeById(id))
        dispatch(getBusinessClients())
    }, [dispatch, id])
    const { codeData } = useSelector((state) => state?.code)
    console.log(codeData)

    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");

    // 🔹 Prefill form
    useEffect(() => {
        if (codeData) {
            form.setFieldsValue({
                code: codeData.code,
                start_date: dayjs(codeData.start_date),
                end_date: dayjs(codeData.end_date),
                no_of_users: codeData.no_of_users,
                business_client: codeData.business_client?._id,
            });
        }
    }, [codeData, form]);

    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");

        const payload = {
            id: id,
            ...values,
        };

        try {
            const resultAction = await dispatch(updateCode(payload));

            if (updateCode.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction.payload?.message || "Code updated successfully");
                setAlertType("success");

                setTimeout(() => {
                    navigate(-1); // 👈 go back after update
                }, 1500);
            } else {
                setAlertMessage(resultAction.payload?.error || "Error updating code");
                setAlertType("error");
            }
        } catch (error) {
            setAlertMessage("Error updating code");
            setAlertType("error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Code</h1>

            <Card title="Edit Code" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === "success" ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage("")}
                        style={{ marginBottom: 24, borderRadius: 8 }}
                    />
                )}

                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                >
                    <Form.Item
                        label="Code"
                        name="code"
                        rules={[{ required: true, message: "Please input code!" }]}
                    >
                        <Input placeholder="Enter code" />
                    </Form.Item>

                    <Form.Item
                        label="Start Date"
                        name="start_date"
                        rules={[{ required: true, message: "Please select start date!" }]}
                    >
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>

                    <Form.Item
                        label="End Date"
                        name="end_date"
                        rules={[{ required: true, message: "Please select end date!" }]}
                    >
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>

                    <Form.Item
                        label="No of Users"
                        name="no_of_users"
                        rules={[{ required: true, message: "Please input no of users!" }]}
                    >
                        <Input placeholder="Enter no of users" />
                    </Form.Item>
                    <Form.Item
                        label="Business Client"
                        name="business_client"
                        rules={[{ required: true, message: 'Please select Business Client' }]}
                    >
                        <Select
                            placeholder="Select Business Client"
                            options={businessClients?.data?.map((data) => ({
                                value: `${data?._id}`,
                                label: `${data?.name}`,
                            }))}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Space>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                size="large"
                                style={{
                                    height: "48px",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    borderRadius: "8px",
                                }}
                            >
                                Update
                            </Button>

                            <Button onClick={() => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default EditCode;